import Vue from 'vue'
import Vuex from 'vuex'

import defaultStates from '@/vuex/defaultStates'
import getters from '@/vuex/getters'
import mutations from '@/vuex/mutations'
import actions from '@/vuex/actions'
import modules from '@/vuex/modules'
import mixpanelContextPlugin from '@/vuex/plugins/mixpanel.context.plugin'
import wordCloudModule from '@/vuex/modules/wordcloud.module'
import actionLog from '@/vuex/actionLog'
import spellcheckerPlugin from '@/vuex/plugins/spellchecker.plugin'

import kvSyncPlugins from '@/vuex/plugins/kvSync'
import subscribeCanvasBlockPluginLegacy from '@/vuex/plugins/canvasBlock.plugin'
import historyPlugin from '@/vuex/modules/history/history.plugin'
import rememberSettingPlugin from '@/vuex/plugins/rememberSetting.plugin'
import remoteControlPlugin from '@/vuex/plugins/remote-control.plugin'
import categoriseModule from '@/vuex/modules/slides/categorise.module'
import planModule from '@/vuex/modules/plan.module'
import slideSettingModule from '@/vuex/modules/slide/slide.setting.module'
import routePrefetchPlugin from '@/vuex/plugins/route-prefetch.plugin'
import localStorageABTestPlugin from '@/vuex/plugins/local-storage-abtest.plugin'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: defaultStates,
  getters,
  mutations,
  actions,
  modules,
  plugins: [
    mixpanelContextPlugin,
    wordCloudModule.plugins.subscribeSlideVersionPlugin,
    ...kvSyncPlugins,
    subscribeCanvasBlockPluginLegacy,
    spellcheckerPlugin,
    historyPlugin,
    rememberSettingPlugin,
    remoteControlPlugin,
    ...categoriseModule.plugins,
    planModule.plugin,
    slideSettingModule.plugin,
    routePrefetchPlugin,
    localStorageABTestPlugin,
  ],
})

// init log action error from vuex
actionLog.initActionLog(store)

export default store
